import * as Pages from '../../pages';

import { VIEW_TYPES } from '../../constants/viewTypes';
import { ROUTE_ACCESS_TYPE } from '../../constants/routeAccessType';

export const projectsRoutes = [
    {
        path: '/projects',
        route_access_type: ROUTE_ACCESS_TYPE.private,
        component: Pages.JobsAndProjectsPage,
        permissionRules: {
            availableViewTypes: [VIEW_TYPES.client],
        },
    },
    {
        path: '/project/:projectId',
        indexPath: '/projects',
        route_access_type: ROUTE_ACCESS_TYPE.private,
        component: Pages.ProjectDetailPage,
        permissionRules: {
            availableViewTypes: [VIEW_TYPES.client],
        },
    },
];
